import React from 'react'

import HelpIcon from '../assets/Help.png'
import InfoCard from '../InfoCard'

const HelpCard = () => (
  <InfoCard
    Image={HelpIcon}
    title="EnrollMe Help"
    message="Get help before, during and after your enrollment."
    url="/help"
    state="completed"
  />
)

export default HelpCard
